<template>
  <TableLayout :permissions="['business:goods:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部商品" name="first"></el-tab-pane>
        <el-tab-pane label="已售罄商品" name="second"></el-tab-pane>
        <el-tab-pane label="回收站商品" name="third"></el-tab-pane>
      </el-tabs>
      <el-form-item label="商品名称" prop="name">
        <el-input v-model="searchForm.name" placeholder="请输入商品名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="商品ID" prop="id">
        <el-input v-model="searchForm.id" placeholder="请输入商品ID" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="所属分类" prop="categoryId">
        <el-select
          v-model="searchForm.categoryId"
          placeholder="请选择所属分类"
        >
          <el-option
            v-for="item in labels"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属品牌" prop="brandId">
        <el-select
          v-model="searchForm.brandId"
          placeholder="请选择所属品牌"
        >
          <el-option
            v-for="item in brands"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="上架状态" prop="status">
        <el-select
          v-model="searchForm.brandId"
          placeholder="请选择上架状态"
        >
          <el-option :key="0" :value="0" label="上架"></el-option>
          <el-option :key="1" :value="1" label="下架"></el-option>
        </el-select>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
        <el-button @click="$refs.operaPlatformGoodsSkuWindow.open('平台SKU')">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:goods:create', 'business:goods:delete']">
        <li><el-button type="primary" @click="$refs.operaGoodsWindow.open('新建商品', null, 1)" v-permissions="['business:goods:create']">新建</el-button></li>
        <li><el-button type="primary" @click="issued(0)">上架</el-button></li>
        <li><el-button type="primary" @click="soldOut(1)">下架</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="商品ID" min-width="100px"></el-table-column>
        <el-table-column prop="imgurl" label="商品信息" min-width="100px">
          <template slot-scope="{row}">
            <el-image :scr="row.imgurlfull" :preview-src-list="[row.imgurlfull]"></el-image>
            {{ row.name }}
          </template>
        </el-table-column>
        <el-table-column prop="categoryName" label="所属分类" min-width="100px"></el-table-column>
        <el-table-column prop="brandName" label="所属品牌" min-width="100px"></el-table-column>
        <el-table-column prop="showPrice" label="展示价格" min-width="100px"></el-table-column>
        <el-table-column prop="salenum" label="库存" min-width="100px"></el-table-column>
        <el-table-column prop="salenum" label="虚拟销量" min-width="100px"></el-table-column>
        <el-table-column prop="salenum" label="实际销量" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="100px"></el-table-column>
        <el-table-column prop="status" label="状态" min-width="100px">
          <template slot-scope="{row}">
            <el-switch
              v-model="row.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="statusChange(row)"
            ></el-switch>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="isrec" label="是否推荐 0否 1是" min-width="100px"></el-table-column>
        <el-table-column prop="styleImg" label="咖豆风味图" min-width="100px"></el-table-column>
        <el-table-column prop="labels" label="商品标签集合,多个用英文逗号隔开" min-width="100px"></el-table-column> -->
        <!-- v-if="containPermissions(['business:goods:update', 'business:goods:delete'])" -->
        <el-table-column

          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <template v-if="row.status==1">
              <el-button type="text" @click="$refs.operaGoodsWindow.open('编辑商品', row, 1)" v-permissions="['business:goods:update']">编辑</el-button>
              <el-button type="text" @click="$refs.operaPlatformGoodsSkuWindow.open('平台SKU', row)">SKU</el-button>
              <el-button type="text" style="color: red;"  @click="deleteById(row)" v-permissions="['business:goods:delete']">删除</el-button>
            </template>
            <template v-else>
              <el-button type="text" @click="$refs.operaGoodsDetailWindow.open('商品详情', row, 0)">查看详情</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaGoodsWindow ref="operaGoodsWindow" @success="handlePageChange"/>
    <OperaGoodsDetailWindow ref="operaGoodsDetailWindow"/>
    <OperaPlatformGoodsSkuWindow ref="operaPlatformGoodsSkuWindow"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaGoodsWindow from '@/components/business/OperaGoodsWindow'
import OperaGoodsDetailWindow from '@/components/business/OperaGoodsDetailWindow'
import OperaPlatformGoodsSkuWindow from '@/components/business/OperaPlatformGoodsSkuWindow'
import { fetchList as labelList } from '@/api/business/labels'
import { updateById } from '@/api/business/goods'
export default {
  name: 'Goods',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaGoodsWindow, OperaGoodsDetailWindow, OperaPlatformGoodsSkuWindow },
  data () {
    return {
      activeName: 'first',
      // 搜索
      searchForm: {
        id: '',
        creator: '',
        createDate: '',
        editor: '',
        editDate: '',
        isdeleted: '',
        remark: '',
        imgurl: '',
        name: '',
        info: '',
        categoryId: '',
        brandId: '',
        price: '',
        salenum: '',
        content: '',
        sortnum: '',
        looknum: '',
        // 类型 0平台商城 1咖豆商城 2咖啡计划商品
        type: '1', // 平台商品
        status: '',
        isrec: '',
        styleImg: '',
        labels: ''
      },
      labels: [],
      brands: [],
    }
  },
  provide() {
    return {
      labels: () => this.labels,
      brands: () => this.brands,
    }
  },
  created () {
    this.config({
      module: '商品信息表',
      api: '/business/goods',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()

    labelList({
      capacity: 999,
      model: {
        type: 0 //商品分类
      }
    })
      .then(res => {
        this.labels = res.records
      })
    labelList({
      capacity: 999,
      model: {
        type: 1 //商品品牌
      }
    })
      .then(res => {
        this.brands = res.records
      })
  },
  methods: {
    handleClick(val) {

    },
    /**
     *
     * @param {上下状态} status 0上架 1下架
     */
    issued(status) {
      if (this.tableData.selectedRows.length === 0) {
        this.$tip.warning('请至少选择一条数据')
        return
      }
      let message = `确认${status==0?'上架':'下架'}选中的商品么?`
      this.$dialog.messageWaring(message)
        .then(() => {

        })
    },

    statusChange(row) {
      updateById(row)
        .then(() => {
          this.$message.success('操作成功')
        })
        .catch(e => {
          this.$message.error('操作成功')
        })
        .then(() => {
          this.handlePageChange()
        })
    }
  },
}
</script>
